<template>
  <div>
    <div class="flipped-class border border-info rounded p-2">
      <div
        class="checkFlippedClass d-flex justify-content-between align-items-baseline mb-2"
      >
        <b-row>
          <b-col sm="12">
            <div class="d-flex">
              <b-form-checkbox
                class="ml-2"
                v-model="flippedClass.checkFlippedClass"
              >
                <p class="btn p-0 m-0 text-info">
                  Flipped Class
                </p>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div v-if="flippedClass.checkFlippedClass">
              <label>Score:</label>
              <b-form-input
                v-model="flippedClass.scoreForFlippedClass"
                placeholder="Enter Score"
                :class="{
                  'form-group-error':
                    $v.flippedClass.scoreForFlippedClass.$error,
                }"
              />
              <span
                class="input-error-message"
                v-if="
                  !$v.flippedClass.scoreForFlippedClass.required &&
                  $v.flippedClass.scoreForFlippedClass.$dirty
                "
              >
                Score is mandatory!
              </span>
            </div>
          </b-col>

          <b-col sm="6">
            <div v-if="flippedClass.checkFlippedClass">
              <label>Best of score:</label>
              <b-form-input
                v-model="flippedClass.best_of_scores"
                placeholder="Optional"
                type="number"
                min="0"
              />
              <small class="form-text text-muted">
                Number of best scores will be considered
              </small>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-collapse
        v-model="flippedClass.checkFlippedClass"
        class="mt-2"
      >
        <div class="mb-2">
          <span class="font-weight-bolder">
            Choose Score Type:
          </span>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th></th>
              <th>Flipped Class</th>
              <th v-if="!activity_simple_calculation">
                Percent Weightage
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="flippedClassFromApi.length === 0">
              <td colspan="100" class="text-center text-danger">
                No Data Found!
              </td>
            </tr>

            <tr
              v-for="(task, index) in flippedClassFromApi"
              :key="index"
            >
              <td>
                <b-form-checkbox
                  size="sm"
                  v-model="
                    flippedClassConfigStructure[task.id].checkbox
                  "
                />
              </td>

              <td>{{ task.name }}</td>

              <td
                v-if="!activity_simple_calculation"
                class="text-center"
              >
                <b-form-input
                  v-if="
                    flippedClassConfigStructure[task.id].checkbox
                  "
                  placeholder="Enter Percentage"
                  v-model="
                    flippedClassConfigStructure[task.id].input
                  "
                  @blur="$v.flippedClassConfigStructure.$each.$touch()"
                />

                <div
                  v-if="
                    flippedClassConfigStructure[task.id].checkbox &&
                    $v.flippedClassConfigStructure.$each[task.id]
                      .input.$error
                  "
                  class="text-danger"
                >
                  <span
                    v-if="
                      !$v.flippedClassConfigStructure.$each[task.id]
                        .input.required
                    "
                  >
                    This field is required.
                  </span>
                  <span
                    v-if="
                      !$v.flippedClassConfigStructure.$each[task.id]
                        .input.customValidation
                    "
                  >
                    All values must be equal or sum to 100.
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  props: ["saved_configs", "courseReport", "activity_simple_calculation"],

  data() {
    return {
      flippedClass: {
        checkFlippedClass: false,
        scoreForFlippedClass: 20,
        best_of_scores: "",
      },
      flippedClassFromApi: [],
      flippedClassConfigStructure: {},
    };
  },

  async created() {
    await this.getFlippedClasses();

    const saved =
      this.saved_configs.activity_catagory_configs.flipped_classes;

    if (saved?.enable) {
      this.flippedClass = {
        checkFlippedClass: saved.enable,
        scoreForFlippedClass: saved.score,
        best_of_scores: saved.best_of_scores,
      };

      Object.keys(saved.resourses.exam || {}).forEach((key) => {
        if (this.flippedClassConfigStructure[key]) {
          this.flippedClassConfigStructure[key].checkbox = true;
          this.flippedClassConfigStructure[key].input =
            saved.resourses.exam[key].persantage_of_wightage;
        }
      });
    }
  },

  validations: {
    flippedClass: {
      scoreForFlippedClass: {
        required: requiredIf(function () {
          return this.flippedClass.checkFlippedClass;
        }),
      },
    },

    flippedClassConfigStructure: {
      $each: {
        input: {
          required() {
            return Object.values(this.flippedClassConfigStructure).some(
              (c) => c.checkbox
            );
          },

          customValidation() {
            if (
              !this.flippedClass.checkFlippedClass ||
              this.activity_simple_calculation
            )
              return true;

            const values = Object.values(
              this.flippedClassConfigStructure
            )
              .filter((c) => c.checkbox)
              .map((c) => Number(c.input));

            if (!values.length) return true;

            const allSame = values.every(
              (v) => v === values[0]
            );
            const sum100 =
              values.reduce((a, b) => a + b, 0) === 100;

            return allSame || sum100;
          },
        },
      },
    },
  },

  methods: {
    async checkValidation() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    async getFlippedClasses() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.courseReport.course_id}/exams`;

      const response = await this.$axios.get(url);

      response.data.forEach((item) => {
        if (item.activity_type === "flipped_class") {
          this.$set(this.flippedClassConfigStructure, item.id, {
            checkbox: false,
            input: "",
          });

          this.flippedClassFromApi.push({
            id: item.id,
            name: item.name,
            maximum_mark: item.maximum_mark,
            date: item.end_at
              ? moment(item.end_at)
              : null,
          });
        }
      });
    },
  },
};
</script>

<style>
.flipped-class p {
  font-size: 16px;
  font-weight: 600;
}
</style>
